/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Animation, Icon } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles('Arrow', {
  root: css({
    opacity: 0,
    height: 16,
    marginLeft: 0,
    marginTop: 2,
    position: 'absolute',
    transition: `opacity 100ms ${Animation.transitionTimingFunction}, margin 150ms ${Animation.transitionTimingFunction}`,
  }),
});

/**
 * @private
 * Indicator arrow for when links are hovered
 */
export const ArrowLinkIcon = () => (
  <span css={Styles.root} data-tag="arrow-icon-wrapper" data-zds>
    <Icon name="arrowBigRight" size={14} />
  </span>
);
